export const LOCALE = 'en-UK';
export const COUNTRY = 'UK';

// pas de conversion
export const UNIT_CONVERTER = (baseUnit: string, ha: number) => {
  // if(baseUnit == "ha") {
  //     // acre
  //     return value * 2.471;
  // } else if(baseUnit == "t") {
  //     // British Unit
  //     // TODO diff USA
  //     // centum weight (cwt) / Hundredweight
  //     return value * 17.857;
  // }
  // // ne devrait pas arriver
  // return undefined;
  return ha;
};

export const CONVERTED_UNIT = (baseUnit: string, isPlural = false) => {
  // if(baseUnit == "ha") {
  //     if(!isPlural) {
  //         return "acre";
  //     }
  //     return "acres";
  // } else if(baseUnit == "t") {
  //     return "cwt";
  // }
  // return undefined;
  return baseUnit;
};

export const NUMBER_FORMATTER = (n: number, options: any) => {
  if (n == null || n == undefined) {
    return '';
  }
  return n.toLocaleString('en-UK', options);
};

export const DATE_FORMATTER = (d: Date) => {
  if (!d) {
    return '';
  }
  return d.toLocaleDateString('en-UK');
};
